import { ScenarioPage, ScenarioPageProps } from '../components/Page';
import useEntryTrack from '../hooks/useEntryTrack';
import { getRouteAccess } from '../Scenario/config';
import createRoute from '../Scenario/createRoute';

export const logisticsRouteAccess = getRouteAccess('配置物流呵护任务');

const pageRoute = createRoute('logistics');

export const route: ScenarioPageProps['route'] = {
  ...pageRoute,
  element: <Logistics />,
  access: logisticsRouteAccess,
};

function Logistics() {
  useEntryTrack('aide/logistics');

  return <ScenarioPage route={pageRoute} />;
}

export default Logistics;
